module.exports = __webpack_public_path__ + "img/time_of_day.033e9e9.png";